module.exports = __webpack_public_path__ + "static/media/vk.84e256a6.png";